import React, { useContext } from "react";
import { NavLink, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DashboardRoutes } from '../../routes/routes';
import { AuthContext } from "../../contexts/AuthContext";
import { sessionService } from "../../sessionService/storage";
import LanguageSelector from "../lang/languageSelector";
import { sourceUrl } from '../../environment';

const Dashboard = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { user, setUser } = useContext(AuthContext);
    const routePath = history.location.pathname;

    const logout = () => {
        setUser(sessionService.destroy());
    }
    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-navbar">
                <div className="navbar navbar-expand-lg navbar-light">
                    <div className="lng-link dash-navbar-mobile">
                        <LanguageSelector />
                    </div>
                    <NavLink className="navbar-brand" to="/"><img className="dash-logo" src="/assets/images/logo.png" alt="PointSnaps" />PointSnaps</NavLink>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="dash-navbar nav navbar-nav dash-navbar-mobile">
                            <li data-toggle="collapse" data-target=".navbar-collapse.show"> 
                                <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/profile">{t('dashboardNav.link.profile')}</NavLink>
                            </li>
                            {user.isCompany || !user.companyId ?
                                <li data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <NavLink className="nav-link" activeClassName='activeNavLink' to={`/dashboard/company/${user._id}`}>{t('dashboardNav.link.company')}</NavLink>
                                </li> : null}
                            <li data-toggle="collapse" data-target=".navbar-collapse.show">
                                <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/folder" >{t('dashboardNav.link.folders')}</NavLink>
                            </li>

                            <li data-toggle="collapse" data-target=".navbar-collapse.show">
                                <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/upload" >{t('dashboardNav.link.upload')}</NavLink>
                            </li>
                            <li data-toggle="collapse" data-target=".navbar-collapse.show">
                                <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/maps" >{t('dashboardNav.link.map')}</NavLink>
                            </li>
                            <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                <NavLink to="/" className="nav-link btn-link" onClick={logout} >{t('logout')}</NavLink>
                            </li>
                        </ul>
                        <div className="dash-navbar-web">
                            <div className="dash-nav-1st">
                                <NavLink className="nav-link" activeClassName='activeNavLink' to="/" >
                                    <img className="dash-logo" src="/assets/images/logo.png" alt="PointSnaps" />
                                    <h4 className="c-white">PointSnaps</h4>
                                </NavLink>
                                <div className="lng-link">
                                    <span> <i className="fa fa-globe" aria-hidden="true"></i> </span><LanguageSelector />
                                </div>
                            </div>
                            <ul className="dash-nav-2nd">
                                {user.isCompany || !user.companyId ?
                                    <li>
                                        <NavLink className="nav-link" activeClassName='activeNavLink' to={`/dashboard/company/${user._id}`}><img  src="/assets/images/company.svg" alt="Company" /></NavLink>
                                    </li> : null}
                                <li>
                                    <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/upload" ><img  src="/assets/images/image.svg" alt="Upload" /></NavLink>
                                </li>

                                <li>
                                    <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/folder" > <img  src="/assets/images/folder.svg" alt="Folders" /></NavLink>
                                </li>

                                <li>
                                    <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/profile"> <img  src="/assets/images/profile.svg" alt="Profil" /></NavLink>
                                </li>
                                <li>
                                    <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/maps" > <img  src="/assets/images/locations.svg" alt="Maps" /></NavLink>
                                </li>
                            </ul>
                            <ul className="dash-nav-3rd">
                                <li className="nav-item">
                                    <NavLink to="/" className="nav-link" onClick={logout} > <img  src="/assets/images/logout.svg" alt="Logout" /></NavLink>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <div className="dashboard-main-container">
                <section className="welcome-container space-around">
                    <div>
                        <div className="avatar-box">
                            <img  src={ user.avatarId ? `${sourceUrl}${user.avatarId}.${user.avatarExt}` :`/assets/images/avatar.png`} alt={user.firstName} />
                        </div>
                        <div>
                            <h6> {t('dashboard.msg.hello')}  <span>{!user.companyName ? `${user.firstName} ${user.lastName}` :`${user.companyName}` } </span>  </h6>
                            {!user.code ? <h5> {t('dashboard.msg.welcome')}  </h5> :<h4 className="dash-user-code">CODE: {user.code}  </h4> }
                        </div>
                    </div>
                    {routePath !== '/dashboard/upload' ? <div className="upload-btn-wrapper">
                        <NavLink to="/dashboard/upload" >  <button type="button" className="btn btn-blue"> {t('dashboardNav.link.upload')} <img  src="/assets/images/upload.svg" alt="Upload" /> </button></NavLink>
                    </div> : null}
                </section>
                <section className="main">
                    <DashboardRoutes />
                </section>
            </div>
        </div>
    );
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboardComponent/dashboard.js